import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import pImg1 from "../../images/gallery/image-7.jpg";
import pImg2 from "../../images/gallery/image-8.jpg";
import pImg3 from "../../images/gallery/image-9.jpg";
import pImg4 from "../../images/gallery/image-10.jpg";
import pImg5 from "../../images/gallery/image-11.jpg";

interface PortfolioSectionS2Props {
  prClass?: string;
}

interface PortfolioItem {
  Pimg: string;
}

const Portfolios: PortfolioItem[] = [
  { Pimg: pImg1 },
  { Pimg: pImg2 },
  { Pimg: pImg3 },
  { Pimg: pImg4 },
  { Pimg: pImg5 },
];

const PortfolioSectionS2: React.FC<PortfolioSectionS2Props> = ({ prClass }) => {
  const [open, setOpen] = useState(false);

  return (
    <section className={`wpo-portfolio-section-s2 ${prClass || ""}`} id="gallery">
      <div className="container-fluid">
        <div className="portfolio-all-items">
          <div className="portfolio-wrap">
            {Portfolios.map((image, i) => (
              <div className="portfolio-items-s2" key={i}>
                <div className="image">
                  <div className="img-holder" onClick={() => setOpen(true)}>
                    <img src={image.Pimg} alt={`Portfolio ${i + 1}`} className="img img-responsive" />
                    <div className="hover-content">
                      <i className="ti-plus"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[
          { src: pImg1 },
          { src: pImg2 },
          { src: pImg3 },
          { src: pImg4 },
          { src: pImg5 },
        ]}
      />
    </section>
  );
};

export default PortfolioSectionS2;
